import apiClient from "../../config/apiClient";


export const fetchDrugs = async (id) => {
    const user = window.localStorage.getItem("token");
    const token = user;
    return await apiClient.get(`/public/portal?url=requests/prescriptions?patient_id=${id}`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  };
  
//24550